// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: #f3f2f0;
}

.Homepagesidebar_Profile__TRYI1 {
  justify-content: space-around;
  margin: 0px 0px 22px 0px;
  /* width:247px; */
  /* max-width: 57%; */
  padding: 26px 20px;
  /* height: 150px; */
  /* background-color: #efeeed; */
  background-color: #ffffff;
  border: solid 1px #dee0e1;
  border-radius: 20px;
  display: flex; /* Ensures the children are laid out in a flex container */
  flex-direction: column; /* Ensures elements stack vertically */
  overflow: hidden; /* Prevents overflow from the container */
  padding-bottom: 5px;
}
.Homepagesidebar_ProfileSignIn__QWDcP {
  justify-content: space-around;
  margin: 0 0px 20px 0px;
  /* width:247px; */
  /* max-width: 57%; */
  padding: 26px;
  /* height: 150px; */
  background-color: #efeeed;
  border: solid 1px #dee0e1;
  border-radius: 20px;
}
.Homepagesidebar_communitycontainer__1ujsJ {
  justify-content: flex-start;
  margin: 12px 0px 25px 0px;
  /* width:247px; */
  /* max-width: 57%; */
  /* padding: 26px; */
  padding-top: 26px;
  padding-bottom: 26px;
  /* height: 150px; */
  /* background-color: #efeeed; */
  background-color: #ffffff;
  border: solid 1px #dee0e1;
  border-radius: 20px;
  height: calc(100vh - 320px);
  overflow-y: scroll;
  scroll-behavior: smooth;
  /* scrollbar-width: none; */
}
.Homepagesidebar_communitycontainer1__66i9z {
  justify-content: flex-start;
  margin: 12px 0px 25px 0px;
  /* width:247px; */
  /* max-width: 57%; */
  padding: 26px 0 26px 26px;
  /* height: 150px; */
  background-color: #efeeed;
  border: solid 1px #dee0e1;
  border-radius: 20px;
}
.Homepagesidebar_communitycontainer__1ujsJ::-webkit-scrollbar {
  width: 0px;
}

.Homepagesidebar_ProfileInfo__ikVJV {
  display: flex;
}

.Homepagesidebar_Profileimg__crQdY {
  border: 1px solid #707070;
  border-radius: 15px;
  width: 47px;
  height: 54px;
}
.Homepagesidebar_Profileimg__crQdY > img {
  width: 100%;
  height: 100%;
  border-radius: 15px;
}

.Homepagesidebar_profilename__6HN6y {
  letter-spacing: 0px;
  margin-bottom: 1px;
  display: flex;
  max-width: 100%;
  align-items: center; /* Ensure text is vertically aligned */
  justify-content: space-between; /* Space out content if needed */
  font-size: 14px;
  font-weight: bold;
  color: #333;
}

.Homepagesidebar_profilename__6HN6y span {
  display: inline-block;
  word-break: break-all;
  /* overflow: hidden;
  text-overflow: ellipsis;  */
  width: 100%;
  color: #373334;
  font-size: 14px;
  font-weight: bold;
}
.Homepagesidebar_ProfileCounts__2eR3E,
.Homepagesidebar_ProfileSummary__tytnR {
  letter-spacing: 0px;
  color: #373334;
  font-size: 12px;
  word-break: break-word;
}
.Homepagesidebar_ProfileDetails__qwjWC {
  margin-left: 12px;
  flex: 1 1;
  min-width: 0;
}

.Homepagesidebar_ProfileActivity__Vkvtn span {
  text-transform: uppercase;
  font-size: 14px;
}

.Homepagesidebar_ProfileSummary__tytnR {
  padding-top: 10px;
  font-weight: 400;
}
.Homepagesidebar_ProfileSummary__tytnR > p {
  padding: 0px 5px 0px 5px;
}

.Homepagesidebar_Community__CbLw5 {
  /* display: flex; */
  /* max-width: 57%; */
  /* width:247px; */
  /* / height: 345px; / */
  /* margin: 20px 30px; */
  margin: 20px 00px;
  /* width:247px; */
  padding: 20px;
  background-color: #efeeed;
  border: none;
  border-radius: 20px;
  box-shadow: -2px -3px 6px #ffffff, 2px 3px 10px #00000029;
}

.Homepagesidebar_communitydivs__8uQjW {
  display: flex;
  flex-flow: row wrap;
}

.Homepagesidebar_Name__iWeTw {
  text-transform: capitalize;
  text-align: center;
}

.Homepagesidebar_CommunitySelction__-Nvi0 {
  display: inline-block;
  width: 100%;
  height: 100%;
  background-color: #efeeed;
  padding: 0px;
  border-radius: 15px;
  border: solid 2px RGBA(0, 0, 0, 0);
  box-shadow: -2px -3px 6px #ffffff, 0px 3px 6px #00000026;
  cursor: pointer;
}

.Homepagesidebar_CommunitySelction__-Nvi0 > p {
  font-size: 12px;
  letter-spacing: 0px;
  color: #000000;
  padding: 4px;
  text-align: center;
  margin-bottom: 4px;
  word-break: break-word;
}
.Homepagesidebar_crad-col__eWxlv.Homepagesidebar_col-6__UDQ11 {
  padding-left: 5px;
  padding-right: 5px;
}
.Homepagesidebar_CommunitySelction__-Nvi0 > img {
  width: inherit;
  border-radius: 15px;
  height: 70px;
  width: 100%;
}

.Homepagesidebar_communitycard__15ERS {
  flex-basis: 42%;
  margin: 4%;
}

.Homepagesidebar_cardContainer__8yx16 {
  display: flex;
  flex-wrap: wrap;
}

.Homepagesidebar_addCommunitySelction__xxMxE {
  flex-basis: 42%;
  margin: 4%;
  background-color: #efeeed;
  border-radius: 15px;
  border: solid 2px RGBA(0, 0, 0, 0);
  box-shadow: -2px -3px 6px #ffffff, 0px 3px 6px #00000026;
  cursor: pointer;
}
.Homepagesidebar_addCommunitySelction__xxMxE:hover {
  border-radius: 15px !important;
  border: 2px solid #4795de;
}

.Homepagesidebar_CommunityImage__3dNKQ {
  /* width: 82px;
    height: 82px; */
  width: -moz-fit-content;
  width: fit-content;
}

.Homepagesidebar_AddCommunityLink__GTBUf {
  background: #e1f0f2;
  align-items: center;
  border-radius: 14px;
}

.Homepagesidebar_AddCommunityimage__uVFzh {
  background: lightblue;
  border-radius: 15px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.Homepagesidebar_followCommTxt__i0wZt {
  font-size: 12px;
  letter-spacing: 0px;
  color: #000000;
  padding: 4px;
  text-align: center;
  margin-bottom: 4px;
}

/* .CommunityImage img {
    width: 100%;
    height: 100%;
} */

.Homepagesidebar_Communityname__MgCGa p {
  font-size: 12px;
  font-weight: 500;
  text-transform: capitalize;
  margin: 0 0 0 5px;
}

.Homepagesidebar_CommunitySelction__-Nvi0:hover {
  border-radius: 15px !important;
  border: 2px solid #4795de;
  width: 100%;
}
.Homepagesidebar_communitySelected__ruIqF {
  border-radius: 17px !important;
  border: 2px solid #4795de;
}

.Homepagesidebar_footer__HHZRl {
  font-size: 12px;
  display: flex;
  flex-wrap: wrap;
  margin: 80px 0px 10px 7px;

  padding: 14px 0px 20px 8px;

  /* background-color: white; */

  /* box-shadow: 3px 3px 3px rgb(163, 177, 198, 0.6),
    -6px -6px 12px rgba(255, 255, 255, 0.5); */
}

.Homepagesidebar_footer__HHZRl > span {
  font-size: 12px;
  font-weight: lighter;
  padding-top: 26px;
  display: block;
  float: left;
  width: 100%;
}

/* .footer div {
    height: 11px;
    margin-bottom: 5px;
    border-right: 1px solid;
    padding: 3px;
} */

/* .footer div:last-child {
    border: none;
} */

.Homepagesidebar_footer__HHZRl P {
  margin: 0;
  font-size: 12px;
  text-transform: capitalize;
}

.Homepagesidebar_CommunityImage__3dNKQ > .Homepagesidebar_followcommunityimage__ASAF4 {
  height: 92px;
}
.Homepagesidebar_mycommunities__aH4Ks {
  width: -webkit-fill-available;

  margin: 0px 0px 10px 14px;
  width: -moz-available;
}
.Homepagesidebar_userprofilename__zZ-Mo {
  margin-bottom: 0;
  font-size: 14px;
}

.Homepagesidebar_editBioTextArea__tDo9G {
  display: none;
}

@media all and (max-width: 991px) {
  /* .cardContainer {
        display: flex;
        flex-wrap: wrap;
    } */
  .Homepagesidebar_communitycard__15ERS {
    flex-basis: 19%;
    margin: 3%;
  }
  .Homepagesidebar_addCommunitySelction__xxMxE {
    flex-basis: 19%;
    margin: 3%;
  }
}

@media all and (min-width: 992px) and (max-width: 1199px) {
  .Homepagesidebar_CommunitySelction__-Nvi0 > img {
    height: 50px;
  }
  .Homepagesidebar_AddCommunityimage__uVFzh {
    height: 50px;
  }
  .Homepagesidebar_communitycard__15ERS {
    flex-basis: 44%;
    margin: 3%;
  }
  .Homepagesidebar_addCommunitySelction__xxMxE {
    flex-basis: 44%;
    margin: 3%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/css/home/Homepagesidebar.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa,EAAE,0DAA0D;EACzE,sBAAsB,EAAE,sCAAsC;EAC9D,gBAAgB,EAAE,yCAAyC;EAC3D,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,+BAA+B;EAC/B,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,mBAAmB,EAAE,sCAAsC;EAC3D,8BAA8B,EAAE,gCAAgC;EAChE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB;6BAC2B;EAC3B,WAAW;EACX,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,yDAAyD;AAC3D;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,wDAAwD;EACxD,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,yBAAyB;EACzB,mBAAmB;EACnB,kCAAkC;EAClC,wDAAwD;EACxD,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE;mBACiB;EACjB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;;GAGG;;AAEH;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,eAAe;EACf,yBAAyB;;EAEzB,0BAA0B;;EAE1B,6BAA6B;;EAE7B;8CAC4C;AAC9C;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,WAAW;AACb;;AAEA;;;;;GAKG;;AAEH;;GAEG;;AAEH;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;AACA;EACE,6BAA6B;;EAE7B,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;;;OAGK;EACL;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;AACF;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;AACF","sourcesContent":["body {\r\n  background-color: #f3f2f0;\r\n}\r\n\r\n.Profile {\r\n  justify-content: space-around;\r\n  margin: 0px 0px 22px 0px;\r\n  /* width:247px; */\r\n  /* max-width: 57%; */\r\n  padding: 26px 20px;\r\n  /* height: 150px; */\r\n  /* background-color: #efeeed; */\r\n  background-color: #ffffff;\r\n  border: solid 1px #dee0e1;\r\n  border-radius: 20px;\r\n  display: flex; /* Ensures the children are laid out in a flex container */\r\n  flex-direction: column; /* Ensures elements stack vertically */\r\n  overflow: hidden; /* Prevents overflow from the container */\r\n  padding-bottom: 5px;\r\n}\r\n.ProfileSignIn {\r\n  justify-content: space-around;\r\n  margin: 0 0px 20px 0px;\r\n  /* width:247px; */\r\n  /* max-width: 57%; */\r\n  padding: 26px;\r\n  /* height: 150px; */\r\n  background-color: #efeeed;\r\n  border: solid 1px #dee0e1;\r\n  border-radius: 20px;\r\n}\r\n.communitycontainer {\r\n  justify-content: flex-start;\r\n  margin: 12px 0px 25px 0px;\r\n  /* width:247px; */\r\n  /* max-width: 57%; */\r\n  /* padding: 26px; */\r\n  padding-top: 26px;\r\n  padding-bottom: 26px;\r\n  /* height: 150px; */\r\n  /* background-color: #efeeed; */\r\n  background-color: #ffffff;\r\n  border: solid 1px #dee0e1;\r\n  border-radius: 20px;\r\n  height: calc(100vh - 320px);\r\n  overflow-y: scroll;\r\n  scroll-behavior: smooth;\r\n  /* scrollbar-width: none; */\r\n}\r\n.communitycontainer1 {\r\n  justify-content: flex-start;\r\n  margin: 12px 0px 25px 0px;\r\n  /* width:247px; */\r\n  /* max-width: 57%; */\r\n  padding: 26px 0 26px 26px;\r\n  /* height: 150px; */\r\n  background-color: #efeeed;\r\n  border: solid 1px #dee0e1;\r\n  border-radius: 20px;\r\n}\r\n.communitycontainer::-webkit-scrollbar {\r\n  width: 0px;\r\n}\r\n\r\n.ProfileInfo {\r\n  display: flex;\r\n}\r\n\r\n.Profileimg {\r\n  border: 1px solid #707070;\r\n  border-radius: 15px;\r\n  width: 47px;\r\n  height: 54px;\r\n}\r\n.Profileimg > img {\r\n  width: 100%;\r\n  height: 100%;\r\n  border-radius: 15px;\r\n}\r\n\r\n.profilename {\r\n  letter-spacing: 0px;\r\n  margin-bottom: 1px;\r\n  display: flex;\r\n  max-width: 100%;\r\n  align-items: center; /* Ensure text is vertically aligned */\r\n  justify-content: space-between; /* Space out content if needed */\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  color: #333;\r\n}\r\n\r\n.profilename span {\r\n  display: inline-block;\r\n  word-break: break-all;\r\n  /* overflow: hidden;\r\n  text-overflow: ellipsis;  */\r\n  width: 100%;\r\n  color: #373334;\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n}\r\n.ProfileCounts,\r\n.ProfileSummary {\r\n  letter-spacing: 0px;\r\n  color: #373334;\r\n  font-size: 12px;\r\n  word-break: break-word;\r\n}\r\n.ProfileDetails {\r\n  margin-left: 12px;\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.ProfileActivity span {\r\n  text-transform: uppercase;\r\n  font-size: 14px;\r\n}\r\n\r\n.ProfileSummary {\r\n  padding-top: 10px;\r\n  font-weight: 400;\r\n}\r\n.ProfileSummary > p {\r\n  padding: 0px 5px 0px 5px;\r\n}\r\n\r\n.Community {\r\n  /* display: flex; */\r\n  /* max-width: 57%; */\r\n  /* width:247px; */\r\n  /* / height: 345px; / */\r\n  /* margin: 20px 30px; */\r\n  margin: 20px 00px;\r\n  /* width:247px; */\r\n  padding: 20px;\r\n  background-color: #efeeed;\r\n  border: none;\r\n  border-radius: 20px;\r\n  box-shadow: -2px -3px 6px #ffffff, 2px 3px 10px #00000029;\r\n}\r\n\r\n.communitydivs {\r\n  display: flex;\r\n  flex-flow: row wrap;\r\n}\r\n\r\n.Name {\r\n  text-transform: capitalize;\r\n  text-align: center;\r\n}\r\n\r\n.CommunitySelction {\r\n  display: inline-block;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: #efeeed;\r\n  padding: 0px;\r\n  border-radius: 15px;\r\n  border: solid 2px RGBA(0, 0, 0, 0);\r\n  box-shadow: -2px -3px 6px #ffffff, 0px 3px 6px #00000026;\r\n  cursor: pointer;\r\n}\r\n\r\n.CommunitySelction > p {\r\n  font-size: 12px;\r\n  letter-spacing: 0px;\r\n  color: #000000;\r\n  padding: 4px;\r\n  text-align: center;\r\n  margin-bottom: 4px;\r\n  word-break: break-word;\r\n}\r\n.crad-col.col-6 {\r\n  padding-left: 5px;\r\n  padding-right: 5px;\r\n}\r\n.CommunitySelction > img {\r\n  width: inherit;\r\n  border-radius: 15px;\r\n  height: 70px;\r\n  width: 100%;\r\n}\r\n\r\n.communitycard {\r\n  flex-basis: 42%;\r\n  margin: 4%;\r\n}\r\n\r\n.cardContainer {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.addCommunitySelction {\r\n  flex-basis: 42%;\r\n  margin: 4%;\r\n  background-color: #efeeed;\r\n  border-radius: 15px;\r\n  border: solid 2px RGBA(0, 0, 0, 0);\r\n  box-shadow: -2px -3px 6px #ffffff, 0px 3px 6px #00000026;\r\n  cursor: pointer;\r\n}\r\n.addCommunitySelction:hover {\r\n  border-radius: 15px !important;\r\n  border: 2px solid #4795de;\r\n}\r\n\r\n.CommunityImage {\r\n  /* width: 82px;\r\n    height: 82px; */\r\n  width: fit-content;\r\n}\r\n\r\n.AddCommunityLink {\r\n  background: #e1f0f2;\r\n  align-items: center;\r\n  border-radius: 14px;\r\n}\r\n\r\n.AddCommunityimage {\r\n  background: lightblue;\r\n  border-radius: 15px;\r\n  height: 70px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.followCommTxt {\r\n  font-size: 12px;\r\n  letter-spacing: 0px;\r\n  color: #000000;\r\n  padding: 4px;\r\n  text-align: center;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n/* .CommunityImage img {\r\n    width: 100%;\r\n    height: 100%;\r\n} */\r\n\r\n.Communityname p {\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  text-transform: capitalize;\r\n  margin: 0 0 0 5px;\r\n}\r\n\r\n.CommunitySelction:hover {\r\n  border-radius: 15px !important;\r\n  border: 2px solid #4795de;\r\n  width: 100%;\r\n}\r\n.communitySelected {\r\n  border-radius: 17px !important;\r\n  border: 2px solid #4795de;\r\n}\r\n\r\n.footer {\r\n  font-size: 12px;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  margin: 80px 0px 10px 7px;\r\n\r\n  padding: 14px 0px 20px 8px;\r\n\r\n  /* background-color: white; */\r\n\r\n  /* box-shadow: 3px 3px 3px rgb(163, 177, 198, 0.6),\r\n    -6px -6px 12px rgba(255, 255, 255, 0.5); */\r\n}\r\n\r\n.footer > span {\r\n  font-size: 12px;\r\n  font-weight: lighter;\r\n  padding-top: 26px;\r\n  display: block;\r\n  float: left;\r\n  width: 100%;\r\n}\r\n\r\n/* .footer div {\r\n    height: 11px;\r\n    margin-bottom: 5px;\r\n    border-right: 1px solid;\r\n    padding: 3px;\r\n} */\r\n\r\n/* .footer div:last-child {\r\n    border: none;\r\n} */\r\n\r\n.footer P {\r\n  margin: 0;\r\n  font-size: 12px;\r\n  text-transform: capitalize;\r\n}\r\n\r\n.CommunityImage > .followcommunityimage {\r\n  height: 92px;\r\n}\r\n.mycommunities {\r\n  width: -webkit-fill-available;\r\n\r\n  margin: 0px 0px 10px 14px;\r\n  width: -moz-available;\r\n}\r\n.userprofilename {\r\n  margin-bottom: 0;\r\n  font-size: 14px;\r\n}\r\n\r\n.editBioTextArea {\r\n  display: none;\r\n}\r\n\r\n@media all and (max-width: 991px) {\r\n  /* .cardContainer {\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n    } */\r\n  .communitycard {\r\n    flex-basis: 19%;\r\n    margin: 3%;\r\n  }\r\n  .addCommunitySelction {\r\n    flex-basis: 19%;\r\n    margin: 3%;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 992px) and (max-width: 1199px) {\r\n  .CommunitySelction > img {\r\n    height: 50px;\r\n  }\r\n  .AddCommunityimage {\r\n    height: 50px;\r\n  }\r\n  .communitycard {\r\n    flex-basis: 44%;\r\n    margin: 3%;\r\n  }\r\n  .addCommunitySelction {\r\n    flex-basis: 44%;\r\n    margin: 3%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Profile": `Homepagesidebar_Profile__TRYI1`,
	"ProfileSignIn": `Homepagesidebar_ProfileSignIn__QWDcP`,
	"communitycontainer": `Homepagesidebar_communitycontainer__1ujsJ`,
	"communitycontainer1": `Homepagesidebar_communitycontainer1__66i9z`,
	"ProfileInfo": `Homepagesidebar_ProfileInfo__ikVJV`,
	"Profileimg": `Homepagesidebar_Profileimg__crQdY`,
	"profilename": `Homepagesidebar_profilename__6HN6y`,
	"ProfileCounts": `Homepagesidebar_ProfileCounts__2eR3E`,
	"ProfileSummary": `Homepagesidebar_ProfileSummary__tytnR`,
	"ProfileDetails": `Homepagesidebar_ProfileDetails__qwjWC`,
	"ProfileActivity": `Homepagesidebar_ProfileActivity__Vkvtn`,
	"Community": `Homepagesidebar_Community__CbLw5`,
	"communitydivs": `Homepagesidebar_communitydivs__8uQjW`,
	"Name": `Homepagesidebar_Name__iWeTw`,
	"CommunitySelction": `Homepagesidebar_CommunitySelction__-Nvi0`,
	"crad-col": `Homepagesidebar_crad-col__eWxlv`,
	"col-6": `Homepagesidebar_col-6__UDQ11`,
	"communitycard": `Homepagesidebar_communitycard__15ERS`,
	"cardContainer": `Homepagesidebar_cardContainer__8yx16`,
	"addCommunitySelction": `Homepagesidebar_addCommunitySelction__xxMxE`,
	"CommunityImage": `Homepagesidebar_CommunityImage__3dNKQ`,
	"AddCommunityLink": `Homepagesidebar_AddCommunityLink__GTBUf`,
	"AddCommunityimage": `Homepagesidebar_AddCommunityimage__uVFzh`,
	"followCommTxt": `Homepagesidebar_followCommTxt__i0wZt`,
	"Communityname": `Homepagesidebar_Communityname__MgCGa`,
	"communitySelected": `Homepagesidebar_communitySelected__ruIqF`,
	"footer": `Homepagesidebar_footer__HHZRl`,
	"followcommunityimage": `Homepagesidebar_followcommunityimage__ASAF4`,
	"mycommunities": `Homepagesidebar_mycommunities__aH4Ks`,
	"userprofilename": `Homepagesidebar_userprofilename__zZ-Mo`,
	"editBioTextArea": `Homepagesidebar_editBioTextArea__tDo9G`
};
export default ___CSS_LOADER_EXPORT___;
